import Swiper from 'swiper/bundle';
(() => {
	const sliderDelay = 5000;
	const selector = '[data-slider]';
	let container = document.querySelector(selector);
	if (container) {
	const swiper = new Swiper(selector, {
		spaceBetween : 30,
		effect: 'fade',
		speed: 500,
		autoplay: {
			delay: sliderDelay,
			disableOnInteraction: true,
		},
		on: {
			slideChange: function() {
				
			}
		}
	});
	// setInterval(() => slider.next(), sliderDelay)
	}

	
	
})();


window.addEventListener('DOMContentLoaded', () => {
	let videos = document.querySelectorAll('.js-video-banner');

	if (!videos.length) {
		return;
	}

	let onResize = () => {
		let size = document.body.clientWidth > 1024 ? 'data-src-mobile' : 'data-src-desktop';
		for (let i=0; i<videos.length; i++) {
			videos[i].innerHTML = `<source src="${videos[i].getAttribute(size)}" type="video/mp4">`;
		}
	};

	window.addEventListener('resize', onResize);
	onResize();
});